import { UPDATE_VISIBILITY } from "./actions";
import { showRegionBanner } from "../components/RegionSelectionBanner";

interface State {
  isVisible: boolean;
}

const initialState: State = {
  isVisible: showRegionBanner(),
};

export const regionSelectionBannerReducer = (state = initialState, action: { type: string; payload: boolean }) => {
  switch (action.type) {
    case UPDATE_VISIBILITY:
      return {
        ...state,
        isVisible: action.payload,
      };
    default:
      return state;
  }
};
